import { render } from "./MeasureTypeCreate.vue?vue&type=template&id=b61d5242&scoped=true"
import script from "./MeasureTypeCreate.vue?vue&type=script&lang=js"
export * from "./MeasureTypeCreate.vue?vue&type=script&lang=js"

import "./MeasureTypeCreate.vue?vue&type=style&index=0&id=b61d5242&scoped=true&lang=css"

import exportComponent from "/Users/shohei/workspace/soei_project/measure_rep_mng/vue3_measure_rep_mng/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b61d5242"]])

export default __exports__